module.exports = __webpack_public_path__ + "static/img/cat.b387c28.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/other/thumbnail/cat.png
// module id = hGeE
// module chunks = 0